import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import kitchenTips from '../../content/cleaning-tips/categories/kitchen.json';

const FeaturedTips = () => {
  const [tipOfTheWeek, setTipOfTheWeek] = useState(null);
  const [recentlyAdded, setRecentlyAdded] = useState([]);

  useEffect(() => {
    // For now, we'll just use the first tip as the tip of the week
    setTipOfTheWeek(kitchenTips[0]);

    // And we'll use all the tips as recently added
    setRecentlyAdded(kitchenTips);
  }, []);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Featured Tips
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" component="h3" gutterBottom>
            Tip of the Week
          </Typography>
          {tipOfTheWeek && (
            <Card>
              <CardContent>
                <Typography variant="h6">{tipOfTheWeek.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {tipOfTheWeek.description}
                </Typography>
                <Button variant="contained" color="primary" sx={{ mt: 2 }}>
                  Read More
                </Button>
              </CardContent>
            </Card>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" component="h3" gutterBottom>
            Recently Added
          </Typography>
          {recentlyAdded.map(tip => (
            <Card key={tip.id} sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">{tip.title}</Typography>
                <Button size="small" sx={{ mt: 1 }}>Read More</Button>
              </CardContent>
            </Card>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeaturedTips;
